import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';

const phrases = [
  { text: 'Thinking', delay: 0 }, // first chunk of text
  { text: '', delay: 0 },
  { text: 'Processing your request, this should take just a moment', delay: 1000 }, // after the first chunk of text 3 seconds
  { text: 'Still working on it', delay: 1000 + 3000 }, // 4 seconds
  { text: 'Finalising my response', delay: 1000 + 3000 + 4000 } //until end
] as const;

const LoadingText = ({ firstChunkArrived }: { firstChunkArrived: boolean }) => {
  const [phraseIndex, setPhraseIndex] = useState(0);

  useEffect(() => {
    const timeouts: ReturnType<typeof setInterval>[] = [];
    if (firstChunkArrived) {
      for (let i = 1; i < phrases.length; i++) {
        timeouts.push(
          setTimeout(() => {
            setPhraseIndex(i);
          }, phrases[i].delay)
        );
      }
    }
    return () => {
      for (const timeout of timeouts) clearTimeout(timeout);
    };
  }, [firstChunkArrived]);
  if (!phrases[phraseIndex].text) return null;
  return (
    <Typography
      sx={{
        fontSize: '14px',
        color: 'var(--GX-Text-Disabled, #6C737A)',
        fontWeight: 500,
        mb: '8px',
        display: 'inline-block',
        '&::after': {
          '@keyframes loadingDots': {
            '0%': { width: 0 },
            '100%': { width: '12px' }
          },
          content: '"..."',
          display: 'inline-block',
          overflow: 'hidden',
          width: 0,
          animation: 'loadingDots 1.5s steps(4, end) infinite',
          verticalAlign: 'bottom'
        }
      }}
    >
      {phrases[phraseIndex].text}
    </Typography>
  );
};

export default LoadingText;
